import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const DEFAULT_VALUE = {
    reportPageViewOnLeafOnly: false,
    warnNestedTrackRoute: true,
};
const Context = createContext(DEFAULT_VALUE);
Context.displayName = 'TrackConfigProvider';
const TrackConfigProvider = ({ children, ...props }) => {
    const value = { ...DEFAULT_VALUE, ...props };
    return (_jsx(Context.Provider, Object.assign({ value: value }, { children: children }), void 0));
};
export default TrackConfigProvider;
export const useTrackConfig = () => useContext(Context);
